import { inject } from "@angular/core";
import { CanActivateFn, UrlTree } from "@angular/router";
import { NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { Observable, from, of } from "rxjs";
import { catchError, first, mergeMap, switchMap } from "rxjs/operators";
import { ModalService } from "@core/services/modal-service/modal.service";
import { SessionUserDataService } from "@shared/services/user-data/session-user-data.service";
import { UserAssignmentNavigationService } from "@core/services/user-assignment-navigation.service";
import { requiresPhoneNumber } from "@shared/helpers/phone-requirement.helper";

export const PhoneNumberGuard: CanActivateFn = (): Observable<boolean | UrlTree> => {
  const sessionUserDataService: SessionUserDataService = inject(SessionUserDataService);
  const userAssignmentNavigation: UserAssignmentNavigationService = inject(
    UserAssignmentNavigationService,
  );
  const modalService: ModalService = inject(ModalService);

  return sessionUserDataService.loadUserData$().pipe(
    first(),
    mergeMap((): Observable<boolean | UrlTree> => {
      const user: ReturnType<SessionUserDataService["user"]> = sessionUserDataService.user();

      if (user?.phoneNumber || !requiresPhoneNumber(user)) return of(true);

      // No convertir en import estatico: el modal arrastra ngx-intl-tel-input
      // y google-libphonenumber, y este guard corre en toda la rama autenticada.
      return from(
        import("@shared/components/registration-completion-modal/registration-completion-modal.component"),
      ).pipe(
        mergeMap(({ RegistrationCompletionModalComponent }) => {
          const modalRef: NgbModalRef = modalService.open({
            component: RegistrationCompletionModalComponent,
          });

          return from(modalRef.result).pipe(
            switchMap((result: boolean) => {
              if (!result) return of(false);

              return userAssignmentNavigation.resolveDefaultHomeUrlTree$();
            }),
          );
        }),
        catchError(() => of(false)),
      );
    }),
    catchError(() => of(false)),
  );
};
